// eslint-disable-next-line no-unused-vars
import {
  // eslint-disable-next-line no-unused-vars
  Alert,
  // eslint-disable-next-line no-unused-vars
  Button,
  // eslint-disable-next-line no-unused-vars
  Col,
  // eslint-disable-next-line no-unused-vars
  Form,
  // eslint-disable-next-line no-unused-vars
  InputNumber,
  message,
  // eslint-disable-next-line no-unused-vars
  Modal,
  // eslint-disable-next-line no-unused-vars
  Row,
  Select,
  // eslint-disable-next-line no-unused-vars
  Spin,
  // eslint-disable-next-line no-unused-vars
  TimePicker,
} from "antd";
import { useContext, useEffect, useRef, useState } from "react";
// eslint-disable-next-line no-unused-vars
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import SimpleReactValidator from "simple-react-validator";
import { translate } from "../../locale";
import ProtocolServices from "../../services/ProtocolServices";
// eslint-disable-next-line no-unused-vars
import PropTypes from "prop-types";
import { SimpleReactValidatorHelper } from "../../helpers/SimpleReactValidatorHelper";
import { AdminContext } from "../../providers/AdminContext";
import { WindowContext } from "../../providers/WindowContext";
// eslint-disable-next-line no-unused-vars
import AddPill from "./AddPill";
// eslint-disable-next-line no-unused-vars
const { Option } = Select;

const AddAppointment = ({ protocolId, visible, onComplete, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [loadingSelect, setLoadingSelect] = useState(false);
  const [surveySelect, setSurveySelect] = useState(null);
  const [pillSelect, setPillSelect] = useState(null);
  const [active, setActive] = useState(false);
  const [showAddPill, setShowAddPill] = useState(false);
  const [values, setValues] = useState({
    turn: 1,
    turn_relative_day: 0,
    type: "",
    form: "",
    pill: "",
    rpm: "",
    persist: 1,
    dispatch_time: dayjs("1970-01-01 12:00", "HH:mm"),
    feeding_day_food: "",
  });
  const [error, setError] = useState("");
  const [, setForceUpdate] = useState();
  const { user } = useContext(AdminContext);
  const [isSuper, setIsSuper] = useState(false);
  const [rpmSelect, setRpmSelect] = useState(null);
  const [timeToRepeat, setTimeToRepeat] = useState(0);
  const [dayFoodSelect, setDayFoodSelect] = useState(null);
  const [recurrentOptionsValues, setRecurrentOptionsValues] = useState({
    repeat: null,
    endOfRepeat: null,
  });
  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
      element: SimpleReactValidatorHelper.elementMessage,
      messages: {
        required: "Campo requerido",
      },
    })
  );
  const { windowIsActive } = useContext(WindowContext);

  const getActions = (visible, windowIsActive, type) => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true) {
        if (windowIsActive && type === "form") {
          loadSurveys();
        }
      }
    }
  };

  useEffect(() => {
    getActions(visible, windowIsActive, values.type);
  }, [visible, windowIsActive, values.type]);

  const checkSuperAdmin = (user) => {
    if (user !== null && user !== undefined) {
      setIsSuper(user.user.rol === "eira-super-admin");
    }
  };

  useEffect(() => {
    checkSuperAdmin(user);
  }, [user]);

  const disabled = () => !simpleValidator.current.allValid();

  const onFinish = async () => {
    setLoading(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      setForceUpdate();
      setError("Todos los datos son requeridos");
      return;
    }
    try {
      const data = {
        protocol: Number.parseInt(protocolId),
        protocol_details: [
          {
            turn: Number.parseInt(values.turn),
            turn_relative_day: Number.parseInt(values.turn_relative_day),
            type: values.type,
            ...(values.type === "form" && { form: values.form }),
            ...(values.type === "pill" && { pill: values.pill }),
            ...(values.type === "rpm" && { record: values.rpm }),
            ...(values.feeding_day_food !== "" && {
              feeding_day_food: values.feeding_day_food,
            }),
            conditions: [],
            dispatch_time: values.dispatch_time.format("HH:mm:ss"),
          },
        ],
      };

      const res = await ProtocolServices.saveProtocolDetails(data);
      if (res?.data?.protocol !== undefined) {
        message.success("El día del protocolo se guardó exitosamente.");
      }
      resetForm();
      if (onComplete) {
        onComplete();
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const resetForm = () => {
    setLoading(false);
    setValues({
      turn: 1,
      turn_relative_day: 0,
      type: "",
      form: "",
      pill: "",
      rpm: "",
      dispatch_time: dayjs("1970-01-01 12:00", "HH:mm"),
      feeding_day_food: "",
    });
    setTimeToRepeat(0);
    setSurveySelect(null);
    setPillSelect(null);
    setRpmSelect(null);
    setDayFoodSelect(null);
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    setRecurrentOptionsValues({ repeat: null, endOfRepeat: null });
    setForceUpdate();
  };

  const loadSurveys = async () => {
    setLoadingSelect(true);
    try {
      let data = {
        page_size: 1000,
        page_num: 1,
      };
      const res = await ProtocolServices.getSurveys(data);
      if (res.status >= 200 && res.status < 300) {
        setSurveySelect(res.data.survey);
      }
      setLoadingSelect(false);
    } catch (error) {
      console.log(error);
      setLoadingSelect(false);
    }
  };

  const loadPills = async () => {
    setLoadingSelect(true);
    try {
      let data = {
        page_size: 10000,
        page_num: 1,
      };
      const res = await ProtocolServices.getPill(data);
      if (res.status >= 200 && res.status < 300) {
        setPillSelect(res.data.pills);
      }
      setLoadingSelect(false);
    } catch (error) {
      console.log(error);
      setLoadingSelect(false);
    }
  };

  const handleChange = (name, value) => {
    if (name === "type") {
      setValues((v) => ({ ...v, form: "", pill: "", rpm: "" }));
      setSurveySelect(null);
      setPillSelect(null);
      setRpmSelect(null);
      setDayFoodSelect(null);
      switch (value) {
        case "form":
          break;
        case "pill":
          loadPills();
          break;
        case "jumpto":
          break;
        case "rpm":
          setRpmSelect([
            { id: "diabetes", name: "Glucemia" },
            { id: "hypertension", name: "Presión arterial" },
            { id: "weight", name: "Peso" },
            { id: "feeding", name: "Alimentación" },
            { id: "o2saturation", name: "Saturación O2" },
            { id: "temperature", name: "Temperatura" },
            { id: "water", name: "Agua" },
          ]);
          break;
      }
    } else if (name === "rpm") {
      setDayFoodSelect(null);
      if (value === "feeding") {
        setDayFoodSelect([
          { name: "Desayuno", id: "desayuno" },
          { name: "Almuerzo", id: "almuerzo" },
          { name: "Merienda", id: "merienda" },
          { name: "Cena", id: "cena" },
          { name: "Colación", id: "colacion" },
        ]);
      }
    }

    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleCancel = () => {
    resetForm();

    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleOnCompletePill = (data) => {
    setPillSelect((v) => {
      let arr = v;
      arr.push(data);
      return arr;
    });
    console.log(data.id);
    setValues((v) => ({ ...v, pill: data.id }));
    setShowAddPill(false);
  };

  const handleOnCancelPill = () => {
    setShowAddPill(false);
  };

  const goToAddForm = () => {
    window.open(process.env.REACT_APP_SURVEY_CREATOR_URL + "/login");
  };

  const getLabel = (value) => {
    if (value === 0) {
      return "Mismo día";
    }
    const day_word = value === -1 || value === 1 ? "día" : "días";

    return value < 0
      ? `${Math.abs(value)} ${day_word} antes`
      : `${value} ${day_word} después`;
  };

  return (
    <>
      <Modal
        open={active}
        title={translate("Agregar acción en turno")}
        onOk={null}
        onCancel={handleCancel}
        footer={false}
      >
        {error && (
          <Alert
            message={error}
            type="error"
            className="mb-6"
            closable
            onClose={() => setError("")}
          />
        )}
        <Form
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          className="w-full"
          layout="vertical"
        >
          <Form.Item label={translate("Turno")}>
            <InputNumber
              placeholder="Número de turno"
              className="border-custom_primary"
              name="turn"
              min={1}
              onChange={(v) => handleChange("turn", v)}
              onBlur={handleBlur}
              value={values.turn}
            />
            {simpleValidator.current.message(
              "turn",
              values.turn,
              "required|min:1,num"
            )}
          </Form.Item>
          <Form.Item label={translate("Días anteriores/posteriores al turno")}>
            <Select
              placeholder="Número de turno"
              className="border-custom_primary"
              name="turn_relative_day"
              onChange={(v) => handleChange("turn_relative_day", v)}
              onBlur={handleBlur}
              options={Array.from({ length: 41 }, (_, i) => {
                const value = i - 20;
                return {
                  value,
                  label: getLabel(value),
                };
              })}
              value={values.turn_relative_day}
            />
            {simpleValidator.current.message(
              "turn_relative_day",
              values.turn_relative_day,
              "required"
            )}
          </Form.Item>
          <Form.Item>
            <div>{translate("Hora de envío de notificaciones")}</div>
            <TimePicker
              format="HH:mm"
              placeholder="00:00"
              className="border-custom_primary"
              name="dispatch_time"
              defaultValue={dayjs("1970-01-01 12:00", "HH:mm")}
              onChange={(time) => handleChange("dispatch_time", time)}
              value={values.dispatch_time}
              minuteStep={10}
            />
            {simpleValidator.current.message(
              "dispatch_time",
              values.dispatch_time === null
                ? ""
                : values.dispatch_time.toString(),
              "required"
            )}
          </Form.Item>

          <Form.Item label={translate("Tipo de acción")}>
            <Select
              name="type"
              placeholder={translate("Seleccione tipo")}
              onChange={(v) => handleChange("type", v)}
              value={values.type}
            >
              <Option value="">{translate("Seleccione tipo")}</Option>
              <Option value="form">{translate("Formulario")}</Option>
              <Option value="pill">{translate("Píldora")}</Option>
              <Option value="rpm">{translate("Registro")}</Option>
              <Option value="telemedicine">{translate("Telemedicina")}</Option>
              <Option value="turn">{translate("Turno")}</Option>
            </Select>
            {simpleValidator.current.message("type", values.type, "required")}
          </Form.Item>

          {surveySelect !== null && (
            <Form.Item>
              <div className="flex flex-row space-x-4">
                <Select
                  showSearch
                  name="form"
                  placeholder={translate("Seleccione formulario")}
                  onChange={(v) => handleChange("form", v)}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {surveySelect.map((survey) => (
                    <Option key={survey.id} value={survey.id}>
                      {survey.title}
                    </Option>
                  ))}
                </Select>
                <Button
                  type="primary"
                  className="bg-custom_primary"
                  onClick={() => goToAddForm()}
                >
                  +
                </Button>
              </div>
              {simpleValidator.current.message("form", values.form, "required")}
            </Form.Item>
          )}

          {pillSelect !== null && (
            <Form.Item>
              <div className="flex flex-row space-x-4">
                <Select
                  className="flex-1"
                  showSearch
                  name="pill"
                  placeholder={translate("Seleccione píldora")}
                  onChange={(v) => handleChange("pill", v)}
                  filterOption={(input, option) => {
                    return option.children
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  value={values.pill}
                >
                  <Option value="">{translate("Seleccione píldora")}</Option>
                  {pillSelect.map((pill) => (
                    <Option key={pill.id} value={pill.id}>
                      {`${
                        pill.enterprises_info[0].name
                          ? `${pill.enterprises_info[0].name} / `
                          : ""
                      }${pill.name}`}
                    </Option>
                  ))}
                </Select>
                {isSuper && (
                  <Button
                    type="primary"
                    className="bg-custom_primary"
                    onClick={() => setShowAddPill(true)}
                  >
                    +
                  </Button>
                )}
              </div>
              {simpleValidator.current.message("pill", values.pill, "required")}
            </Form.Item>
          )}

          {rpmSelect !== null && (
            <Form.Item>
              <div className="flex flex-row space-x-4">
                <Select
                  className="flex-1"
                  showSearch
                  name="rpm"
                  placeholder={translate("Seleccione registro")}
                  onChange={(v) => handleChange("rpm", v)}
                  filterOption={(input, option) => {
                    return option.children
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  value={values.rpm}
                >
                  <Option value="">{translate("Seleccione registro")}</Option>
                  {rpmSelect.map((rpm) => (
                    <Option key={rpm.id} value={rpm.id}>
                      {rpm.name}
                    </Option>
                  ))}
                </Select>
              </div>
              {simpleValidator.current.message("rpm", values.rpm, "required")}
            </Form.Item>
          )}

          {dayFoodSelect !== null && (
            <Form.Item>
              <div className="flex flex-row space-x-4">
                <Select
                  className="flex-1"
                  showSearch
                  name="feeding_day_food"
                  placeholder={translate("Seleccione alimento")}
                  onChange={(v) => handleChange("feeding_day_food", v)}
                  filterOption={(input, option) => {
                    return option.children
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  value={values.feeding_day_food}
                >
                  <Option value="">{translate("Seleccione alimento")}</Option>
                  {dayFoodSelect.map((feeding_day_food) => (
                    <Option
                      key={feeding_day_food.id}
                      value={feeding_day_food.id}
                    >
                      {feeding_day_food.name}
                    </Option>
                  ))}
                </Select>
              </div>
            </Form.Item>
          )}

          {loadingSelect && (
            <Form.Item className="text-center">
              <Spin indicator={<LoadingOutlined />} />
            </Form.Item>
          )}

          <div className="mb-2">
            {recurrentOptionsValues.repeat &&
              recurrentOptionsValues.repeat !== "Ninguna" &&
              `Se repite cada ${recurrentOptionsValues.repeat} días.`}
            {timeToRepeat !== 0 && ` Termina luego de ${timeToRepeat} veces`}
          </div>

          <Form.Item>
            <Row align="end" gutter={16}>
              <Col>
                <Button key="back" onClick={handleCancel}>
                  {translate("Cancelar")}
                </Button>
              </Col>
              <Col>
                <Button
                  disabled={disabled()}
                  htmlType="submit"
                  type="primary"
                  className="bg-custom_primary"
                >
                  {loading ? (
                    <Spin
                      indicator={
                        <LoadingOutlined style={{ color: "#666666" }} />
                      }
                    />
                  ) : (
                    "Guardar"
                  )}
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
      <AddPill
        visible={showAddPill}
        onComplete={handleOnCompletePill}
        onCancel={handleOnCancelPill}
      />
    </>
  );
};

AddAppointment.propTypes = {
  protocolId: PropTypes.string,
  visible: PropTypes.bool,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func,
};

export default AddAppointment;
